export default __webpack_public_path__ + "static/media/blank.deaa111f.jpg";